import { defineMessages } from '@jutro/locale';

export default defineMessages({
    savedQuote: {
        id: 'ml.gateway.MLBundleQuestionPopup.Saved Quote',
        defaultMessage: 'Saved Quote'
    },
    includeBundle: {
        id: 'ml.gateway.MLBundleQuestionPopup.Do you want to include this quote as part of a bundle?',
        defaultMessage: 'Do you want to include this quote as part of a bundle?'
    },
    keepMonoline: {
        id: 'ml.gateway.MLBundleQuestionPopup.KEEP MONOLINE',
        defaultMessage: 'KEEP MONOLINE'
    },
    bundle: {
        id: 'ml.gateway.MLBundleQuestionPopup.BUNDLE',
        defaultMessage: 'BUNDLE'
    },
    mlPeriodStartDatePopupTitle: {
        id: 'ml.gateway.MLBundleQuestionPopup.Please review the effective date as it’s a date in the past',
        defaultMessage: 'Please review the effective date as it’s a date in the past'
    },
});
